import {
  drawerWidth,
  headerHeight,
  footerHeight,
  transition,
  container,
} from "assets/jss/material-dashboard-react.js";
import brandTheme from "brandTheme/Theme";

const appStyle = (theme) => ({
  wrapper: {
    position: "relative",
    top: "0",

    // height: "100vh",
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      // width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch",
    height:'100vh'
  },
  content: {
    // marginTop: `${headerHeight}px`,
    width: "100%",
    //padding: "30px 15px",
    minHeight: "calc(100vh - 130px)",
    alignItems:'center',
    justifyContent:'center',
  },
  container,
  map: {
    marginTop: `${headerHeight}px)`,
  },
    drawerGetApp: {
    border: `1px solid ${brandTheme.secondaryColor}`,
    width: "90%",
    margin: "20px auto",
    borderRadius: "50px",
    background: brandTheme.secondaryColor,
    color: brandTheme.white,
    textAlign: "center",
    '&:hover':{
          background: brandTheme.secondaryColor,
    }
  },
  
});

export default appStyle;
